import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";

const orderCancelReason = [
  { id: 1, name: "The customer wanted to cancel the order" },
  { id: 2, name: "Payment was declined" },
  { id: 3, name: "The order was fraudulent" },
  { id: 4, name: "There was insufficient inventory" },
  { id: 5, name: "The order was cancelled for an unlisted reason" },
  { id: 6, name: "Staff made an error" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
  }),
};

function OrderCancelForm(props) {
  const { control, errors, register, setValue, trigger, getValues } = props;

  console.log("errors", errors)
  return (
    <Fragment>
      <div className="p-2">
        <Row>
          <Col sm={12}>
            <FormGroup>
              <Label className="col-form-label" style={{ fontSize: 14, fontWeight: 500 }}>
                Reason for cancellation <span style={{color:"red"}}>*</span>
              </Label>
              <Select
                placeholder={<div>Select the reason...</div>}
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                // cacheOptions
                styles={customStyles}
                // defaultValue={backInRequestState.filter.country}
                options={orderCancelReason}
                onChange={(e) => {
                  setValue("reason", e ? e : null);
                  trigger("reason");
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
              <span style={{color :"red"}}>{errors.reason?.message}</span>
            </FormGroup>
          </Col>

          <Col sm={12}>
            <FormGroup>
              <Label className="form-label" style={{ fontSize: 14, fontWeight: 500 }}>Staff notes</Label>
              <textarea {...register("staff_note")} className="form-control" rows={3} style={{fontSize: 13}}></textarea>
              <span style={{fontWeight:500 , color:"#2f2f2f96"}}>Only you and other staff can see this note.</span>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <FormGroup>
              <Input id="checkbox1" type="checkbox" style={{ marginLeft: 0, marginTop: "0.2rem" }} onChange={(e) => setValue("notify_customer", e.target.checked)}/>
              <Label className="form-label" for="checkbox1" style={{ marginLeft: 20, fontSize: 13, fontWeight:500}}>
                Notify the customer
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
}

export default OrderCancelForm;
